export default __webpack_public_path__ + "locales/pl/PrivacyPage.json?hash=5e8f5eb44a5fba6536b14ca55e6659bb";